module.exports = {
      id: "group-usage",
      viewBox: "0 0 11 10",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#group",
      toString: function () {
        return this.url;
      }
    }